var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ll-classification-wrap"},[_c('p',{staticClass:"ll-classification-wrap_title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]),_c('div',{staticClass:"ll-classification-wrap_content",class:[{'bg-white':_vm.bgWhite}]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }